
<template>
	<app-layout>
	  <!-- <PageTitle :headerTitle="title"> </PageTitle> -->
	  <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
		<br />
  
		<progressstep step="3"></progressstep>
  
		<div class="">
		  <!-- <div class="title mt-4 mx-4">
			<h4>Place Order</h4>
		  </div> -->
  
		  <div class="d-flex">
			
			<div class="detail">
				 
				  <div class="my-2">
					<div class="font-semibold text-lg text-gray-800 leading-tight">Place Order</div>
					<p class="text-xs">View the details of Place Order details record.</p> 
				  </div>
			  <!-- <h6 class="font-bold">Order Details</h6> -->
			  <details>
				<summary>
				  <div class="text-base font-medium">
					  <h6 >Tenant</h6>
					  <!-- <small>Tenant Name</small> -->
					<span class="plus">{{ organisationName }}</span>
				  </div>
				</summary>
			  </details>
			  <details>
				<summary>
				  <div class="text-base font-medium">
					  <h6>Billing Details</h6>
				  </div>
				  <div class="grid grid-cols-2 gap-4">
					<div class="text-gray-800 font-bold text-xs ml-4">{{ billingName }}</div>
					<!-- ... -->
  
					<!-- <div  class="justify-end text-gray-400 font-bold">{{billingGstin}}</div> -->
					<div class="flex justify-end">
					  <div class="text-gray-700 text-sm ml-4">GSTIN:</div>
					  &nbsp; &nbsp;
					  <div class="text-gray-800 font-bold text-xs font-bold">
						{{ billingGstin }}
					  </div>
					</div>
				  </div>
  
				  <div class="grid grid-cols-2 gap-4">
					<div class="text-gray-800 font-bold text-xs ml-4">{{ billingAddress }}</div>
					<!-- ... -->
					<div class="flex justify-end">
					  <div class="text-gray-700 text-sm ml-4">PAN:</div>
					  &nbsp; &nbsp;
					  <div class="text-gray-800 font-bold text-xs font-bold">{{ billingPan }}</div>
					</div>
					<!-- <div  class="justify-end text-gray-400 font-bold">{{billingPan}}</div> -->
				  </div>
				</summary>
			  </details>
			  <details>
				<summary>
				  <div class="text-base font-medium">
					
					  <h6>Product Details</h6>
					
					<!-- <span class="plus">{{product}}</span> -->
				  </div>
  
				  <div class="grid grid-cols-2 gap-4">
					<div class="text-gray-700 text-sm ml-4">Product</div>
					<!-- ... -->
					<div class="justify-end text-gray-800 font-bold text-xs">
					  {{ selectedProductFamilyName }}
					</div>
				  </div>
				  <div class="grid grid-cols-2 gap-4">
					<div class="text-gray-700 text-sm ml-4">Plan</div>
					<!-- ... -->
					<div class="justify-end text-gray-800 font-bold text-xs">
					  {{ subscriptionPlan }}
					</div>
				  </div>
				  <div class="grid grid-cols-2 gap-4">
					<div class="text-gray-700 text-sm ml-4">Frequency</div>
					<!-- ... -->
					<div class="justify-end text-gray-800 font-bold text-xs">
					  {{ frequency }}
					</div>
				  </div>
				</summary>
			  </details>
			</div>
  
			<div class="Yorder">
				<sum class="sums">
					<div class="grid grid-cols-2 gap-4 mb-2">
					  <div class="font-semibold text-lg text-gray-800 leading-tight">Order Summary</div>
					  <!-- ... -->
					</div>
				  </sum>
			  <table>
				
  
				<!-- pricing user -->
				<details>
				  <summary class="">
					<div class="grid grid-cols-2 gap-4 my-1">
					  <div class="text-gray-700 text-sm">Price/User</div>
					  <!-- ... -->
					  <div class="flex justify-end">
						&nbsp; &nbsp;
						<div class="text-gray-800 font-bold text-xs">
						  {{ subscriptionPrice }}
						</div>
					  </div>
					</div>
				  </summary>
				</details>
				<!-- pricing user end -->
				
				<!-- no. of user start -->
				<details>
				  <summary class="">
					<div class="grid grid-cols-2 gap-4">
					  <div class="text-gray-700 text-sm">No. of User</div>
					  <!-- ... -->
					  <div class="flex justify-end">
						<span class="">
						  <input
							:value="this.number_of_user"
							class="form-control"
							@change="updateNumberOfUser"
							type="number"
							min="1"
							id="nou"
						  />
						</span>
  
					  </div>
					</div>
				  </summary>
				</details>
  
				<!-- total amount -->
				<details>
				  <summary class="">
					<div class="grid grid-cols-2 gap-4">
					  <div class="text-gray-700 text-sm">Total</div>
					  <!-- ... -->
					  <div class="flex justify-end">
						&nbsp; &nbsp;
						<div class="text-gray-800 font-bold text-xs">
						  {{ total_amount }}
						</div>
					  </div>
					</div>
				  </summary>
				</details>
				<!-- total amount end -->
				<!-- <tr>
				  <td>GST</td>
				  <td>{{ gst_value }}</td>
				</tr> -->
  
				<!-- igst start from here -->
				<details v-show="isIGST">
				  <summary class="">
					<div class="grid grid-cols-2 gap-4">
					  <div class="text-gray-700 text-sm">IGST</div>
					  <!-- ... -->
					  <div class="flex justify-end">
						&nbsp; &nbsp;
						<div class="text-gray-800 font-bold text-xs">
						  {{ gst_value }}
						</div>
					  </div>
					</div>
				  </summary>
				</details>
				<!-- sgst start from here -->
				<details v-show="!isIGST">
				  <summary class="">
					<div class="grid grid-cols-2 gap-4">
					  <div class="text-gray-700 text-sm">SGST</div>
					  <!-- ... -->
					  <div class="flex justify-end">
						&nbsp; &nbsp;
						<div class="text-gray-800 font-bold text-xs">
						  {{ sgst_value }}
						</div>
					  </div>
					</div>
				  </summary>
				</details>
  
				<!-- cgst start from here -->
				<details v-show="!isIGST">
				  <summary class="">
					<div class="grid grid-cols-2 gap-4">
					  <div class="text-gray-700 text-sm">CGST</div>
					  <!-- ... -->
					  <div class="flex justify-end">
						&nbsp; &nbsp;
						<div class="text-gray-800 font-bold text-xs">
						  {{ cgst_value }}
						</div>
					  </div>
					</div>
				  </summary>
				</details>
  
				<!-- gst end -->
  
				<!-- roundOff start from here -->
				<details>
				  <summary class="">
					<div class="grid grid-cols-2 gap-4">
					  <div class="text-gray-700 text-sm">Round Off</div>
					  <!-- ... -->
					  <div class="flex justify-end">
						&nbsp; &nbsp;
						<div class="text-gray-800 font-bold text-xs">
						  {{ round_off_value }}
						</div>
					  </div>
					</div>
				  </summary>
				</details>
  
				<!-- gst end -->
  
				<!-- <tr>
				  <td>Order Value</td>
				  <td>{{ order_value }}</td>
				</tr> -->
				<!-- order value -->
				<details>
				  <summary class="">
					<div class="grid grid-cols-2 gap-4">
					  <div class="text-gray-700 text-sm">Order Value</div>
					  <!-- ... -->
					  <div class="flex justify-end">
						&nbsp; &nbsp;
						<div class="text-gray-800 font-bold text-xs">
						  {{ order_value }}
						</div>
					  </div>
					</div>
				  </summary>
				</details>
				<!-- order value end -->
			  </table>
			  <br />
  
			  <!-- button start from here -->
			  <div>
				<button
				  v-on:click="placeOrder()"
				  class="rounded bg-green-500 px-4 py-2 text-white"
				>
				  Place Order
				</button>
			  </div>
			  <!-- Yorder -->
			</div>
		  </div>
		</div>
	  </div>
	</app-layout>
  </template>
  
  <script>
  import Progressstep from "../Views/Components/UpgradeProgressbar.vue";
  import AppLayout from "@/Layouts/AppLayout.vue";
  import PageTitle from "@/Layouts/PageTitle.vue";
  
  export default {
	props: {
	  subscriptionPlanId: String,
	  subscriptionPlan: String,
	  productId: String,
	  product: String,
	  subscriptionPriceId: String,
	  subscriptionPriceName: String,
	  subscriptionPrice: String,
	  organisationName: String,
	  organisationId: String,
	  billingId: String,
	  frequency: String,
	  billingName: String,
	  billingAddress: String,
	  billingGstin: String,
	  billingPan: String,
	  isIGST: Boolean,
	  subscriptionProductId:String,
	  selectedProductFamilyName:String,
	  billingAddressId:String
	},
  
	components: {
	  Progressstep,
	  AppLayout,
	  PageTitle,
	},
	data() {
	  return {
		title: "Checkout",
		number_of_user: 1,
		total_amount: 0,
		gst_value: 0,
		sgst_value: 0,
		cgst_value: 0,
		order_value: 0,
		round_off_value: 0,
	  };
	},
	methods: {
	  updateNumberOfUser(event) {
		this.number_of_user = event.target.value;
		this.total_amount = (
		  this.number_of_user * this.subscriptionPrice
		).toFixed(2);
  
		// this.total_amount= (parseFloat(this.subscriptionPrice)).toFixed(2);
		if (this.isIGST == true) {
		  this.gst_value = ((this.total_amount * 18) / 100).toFixed(2);
		  this.sgst_value = 0;
		  this.cgst_value = 0;
		  let orignalValue = (
			parseFloat(this.total_amount) + parseFloat(this.gst_value)
		  ).toFixed(2);
		  this.order_value = Math.round(
			(parseFloat(this.total_amount) + parseFloat(this.gst_value)).toFixed(
			  2
			)
		  );
		  this.round_off_value = (this.order_value - orignalValue).toFixed(2);
		} else {
		  this.sgst_value = ((this.total_amount * 9) / 100).toFixed(2);
		  this.cgst_value = ((this.total_amount * 9) / 100).toFixed(2);
		  this.gst_value = 0;
		  let orignalValue = (
			parseFloat(this.total_amount) +
			parseFloat(this.sgst_value) +
			parseFloat(this.cgst_value)
		  ).toFixed(2);
		  this.order_value = Math.round(
			(
			  parseFloat(this.total_amount) +
			  parseFloat(this.sgst_value) +
			  parseFloat(this.cgst_value)
			).toFixed(2)
		  );
		  this.round_off_value = (this.order_value - orignalValue).toFixed(2);
		}
  
		// this.order_value=this.total_amount+((this.total_amount*this.gst_value)/100).toFixed(2);
	  },
	  placeOrder() {
		var data = {
		  productId: this.productId,
		  product: this.product,
		  subscriptionPlanId: this.subscriptionPlanId,
		  subscriptionPlan: this.subscriptionPlan,
		  subscriptionPriceId: this.subscriptionPriceId,
		  subscriptionPriceName: this.subscriptionPriceName,
		  subscriptionPrice: this.subscriptionPrice,
		  organisationId: this.organisationId,
		  organisationName: this.organisationName,
		  billingId: this.billingId,
		  frequency: this.frequency,
		  billingName: this.billingName,
		  numberOfUser: this.number_of_user,
		  totalAmount: this.total_amount,
		  orderValue: this.order_value,
		 
		  billingAddress: this.billingAddress,
		  billingGstin: this.billingGstin,
		  billingPan: this.billingPan,
		  isIGST:this.isIGST,
		  gstValue: this.gst_value,
		  sgstValue:this.sgst_value,
		  cgstValue:this.cgst_value,
		  roundOffValue:this.round_off_value,
		  selectedProductFamilyName:this.selectedProductFamilyName,
		  subscriptionProductId:this.subscriptionProductId,
		  billingAddressId:this.billingAddressId,
		};
  
		this.$inertia.post(route("marketplaces.checkout"), data);
	  },
	},
	mounted() {
	  this.total_amount = parseFloat(this.subscriptionPrice).toFixed(2);
  
	  if (this.isIGST == true) {
		this.gst_value = ((this.total_amount * 18) / 100).toFixed(2);
		this.sgst_value = 0;
		this.cgst_value = 0;
		this.order_value = Math.round(
		  (parseFloat(this.total_amount) + parseFloat(this.gst_value)).toFixed(2)
		);
  
		var orignalValue = (
		  parseFloat(this.total_amount) + parseFloat(this.gst_value)
		).toFixed(2);
  
		this.round_off_value = (this.order_value - orignalValue).toFixed(2);
	  } else {
		this.sgst_value = ((this.total_amount * 9) / 100).toFixed(2);
		this.cgst_value = ((this.total_amount * 9) / 100).toFixed(2);
		this.gst_value = 0;
  
		this.order_value = Math.round(
		  (
			parseFloat(this.total_amount) +
			parseFloat(this.sgst_value) +
			parseFloat(this.cgst_value)
		  ).toFixed(2)
		);
  
		let orignalValue = (
		  parseFloat(this.total_amount) +
		  parseFloat(this.sgst_value) +
		  parseFloat(this.cgst_value)
		).toFixed(2);
  
		this.round_off_value = (this.order_value - orignalValue).toFixed(2);
	  }
	},
  };
  </script>
  
  
  <style>
  .form-control {
	width: 100%;
	margin-left: 50%;
  }
  .d-flex {
	display: flex;
	flex-direction: row;
	/* background: #f6f6f6; */
	border-radius: 0 0 5px 5px;
	padding: 8px 25px;
  }
  .left {
	flex: 4;
  }
  
  .detail {
	flex: 4;
	padding: 15px 25px;
	margin: 5px 10px 15px 0px;
	border: 1px solid #dadada;
	background-color: white;
	height: 500px;
  }
  
  h2 {
	margin: 0;
	padding-left: 15px;
  }
  .required {
	color: red;
  }
  label,
  table {
	display: block;
	margin: 15px;
  }
  label > span {
	float: left;
	width: 25%;
	margin-top: 12px;
	padding-right: 10px;
  }
  select {
	width: 72%;
	height: 45px;
	padding: 5px 10px;
	margin-bottom: 10px;
  }
  .Yorder {
	margin-top: 5px;
	height: 500px;
	padding: 20px;
	border: 1px solid #dadada;
	background-color: white;
	flex: 2;
  }
  
  table {
	margin: 0;
	padding: 0;
  }
  th {
	border-bottom: 1px solid #dadada;
	padding: 10px 0;
  }
  tr > td:nth-child(1) {
	text-align: left;
	color: #2d2d2a;
  }
  tr > td:nth-child(2) {
	text-align: right;
	color: #52ad9c;
	margin-right: 40px;
  }
  td {
	border-bottom: 1px solid #dadada;
	padding: 10px 5px 10px 0;
  }
  
  p {
	display: block;
	color: #888;
	margin: 0;
	/* padding-left: 25px; */
  }
  .Yorder > div {
	padding: 15px 0;
  }
  
  button {
	width: 100%;
	margin-top: 10px;
	padding: 10px;
	border: none;
	border-radius: 30px;
	background: #52ad9c;
	color: #fff;
	font-size: 15px;
	font-weight: bold;
  }
  button:hover {
	cursor: pointer;
	background: #428a7d;
  }
  
  /* left detail css */
  section {
	width: 90%;
	max-width: 800px;
	margin-left: auto;
	margin-right: auto;
  }
  section + section {
	margin-top: 2.5em;
  }
  
  summary {
	/* background-color: #fff; */
	position: relative;
	/* cursor: pointer; */
	padding: 0.6em 0.3em;
	list-style: none;
  }
  summary::-webkit-details-marker {
	display: none;
  }
  summary:hover {
	background-color: #f2f5f9;
  }
  summary .sums:hover {
	background-color: #FFFFFF !important;
  }
  summary div {
	display: flex;
	align-items: center;
  }
  summary h5 {
	display: flex;
	flex-direction: column;
  }
  summary small {
	color: #999;
	font-size: 15px;
  }
  summary strong {
	font-weight: 600;
	font-size: 18px;
  }
  
  summary span:first-child {
	/* width: 2rem; */
	height: 2rem;
	border-radius: 10px;
	/* background-color: #e0ece4; */
	display: flex;
	flex-shrink: 0;
	align-items: center;
	justify-content: center;
  }
 
  summary span:last-child {
	font-weight: 700;
	margin-left: auto;
  }
  summary:focus {
	outline: none;
  }
  summary .plus {
	color: rgb(101, 100, 100);
  }
  summary span:last-child {
	font-weight: 700;
  }
  summary .plu {
	margin-top: 4px;
	color: #999;
	margin-left: auto;
  }
  
  details {
	border-bottom: 1px solid #dadada;
  }
  
  img,
  video {
	max-width: 50%;
	height: auto;
  }
  
  
  h4 {
	margin-bottom: 0rem;
	font-weight: 500;
	line-height: 1.2;
  }
  </style>
  
  